const moment = require("moment/moment");

const selectedSalarySlipEmployeeExternalIds = new Set();
const employeeAnalyticsLoadingIndicator =
  "<div class='d-flex align-items-center justify-content-center' style='height: 50vh' role='status'>" +
    "<div class='spinner-grow text-dark'></div><span class='ml-2'>Loading chart...</span>" +
  "</div>";

const updateSelectedSalarySlipEmployeeCheckboxes = () => {
  $(".salary-slip-employee-checkbox").each((_index, checkbox) => {
    checkbox.checked = selectedSalarySlipEmployeeExternalIds.has(checkbox.value);
  });
  $("#select-all-salary-slips").prop(
    "checked",
    $(".salary-slip-employee-checkbox").length > 0 &&
      $(".salary-slip-employee-checkbox:not(:checked)").length === 0
  );
};

document.addEventListener('DOMContentLoaded', () => {
  const requestedTab = $('#nav-tab a[data-toggle="tab"]').filter((_index, tab) => (
    $(tab).attr('href') === window.location.hash
  ));
  const employeeTab = requestedTab.length ? requestedTab : $('#salary-history-tab');
  employeeTab.tab('show');

  $('.help-text').tooltip({
    template: '<div class="tooltip" role="tooltip">\
                <div class="tooltip-arrow"></div>\
                <div class="tooltip-inner help-text-tooltip"></div>\
               </div>'
  });

  render_employees_table();
  $('.pf-month-datepicker').each((_index, field) => {
    const container = $(field).closest('[show-pf-history]');
    $(field).datetimepicker({
      format: 'MMM, YYYY', viewMode: 'months', useCurrent: false, ignoreReadonly: true,
      minDate: moment(container.find('#pf_history_from').data('min-date')),
      maxDate: moment(container.attr('data-max-month')).endOf('month'),
      icons: { previous: 'fas fa-chevron-left', next: 'fas fa-chevron-right' }
    });
  });
  $('.custom_month_range_picker_template').each((_index, element) => {
    initialize_custom_month_range($(element));
  });
  display_employee_analytics($('.employee-analytics-form').first());
  initialize_remarks_datatable();

  $(document).on('click', '.view-remarks-icon', function(e) {
    e.stopPropagation();
    const employeeId = $(this).data('employee-id');
    $.ajax({
      url: `/employees/${employeeId}/remarks`,
      method: 'GET',
      success: function(response) {
        $('#view-remarks-modal .modal-content').html(response);
        $('#view-remarks-modal').modal('show');
      }
    });
  });
});

$(document).on('submit', '#generate-tax-certificate-form', () => {
  $('#generateTaxCertificateModal').modal('hide');
  append_success_message_in_alert_container('Tax certificate download started successfully.');
  window.scrollTo({ top: 0, behavior: 'smooth' });
});

const render_employees_table = () => {
  $('#employee-table').DataTable({
    fixedHeader: true,
    processing: true,
    serverSide: true,
    order: [[1, 'asc']],
    ajax: {
      'type': 'get',
      'url': '/employees',
      'dataType': 'json',
      'data': (data) => {
        data.page = parseInt($('#employee-table').DataTable().page.info().page) + 1
        data.per_page = $('#employee-table').DataTable().page.info().length
        data.search = { text: data.search.value,
                        business_unit: $('#select-business-unit-filter').val(),
                        user_type: $('#select-user-type-filter').val(),
                        filter: $('#select-employees-status').val() }
        data.order = $('#employee-table').DataTable().order()[0][0]
        data.direction = $('#employee-table').DataTable().order()[0][1]
      }
    },
    drawCallback: () => {
      updateSelectedSalarySlipEmployeeCheckboxes();
    },
    deferRender: true,
    columnDefs: [
      {
        'targets': 0,
        "bSortable": false,
        'createdCell': (td) => {
          $(td).addClass('disable-propagation text-center')
        }
      },
      {
        'targets': 2,
        'createdCell': (td, cellData, rowData, row, col) => {
          $(td).addClass('cursor-pointer employee-row')
          $(td).attr('onClick', `window.open('/employees/${rowData[1]}', '_blank')`)
        }
      },
      {
        'targets': 7,
        'className': 'designation-display-text',
        "bSortable": false
      },
      {
        'targets': 8,
        'className': 'text-center',
        'createdCell': (td, cellData, rowData) => {
          $(td).html('');
          const remarksData = rowData[8];
          if (remarksData && remarksData.count > 0) {
            const iconHtml = `<i class="fas fa-comment-alt view-remarks-icon cursor-pointer" data-employee-id="${rowData[1]}" title="View Remarks"></i>`;
            $(td).html(iconHtml);
          }
        },
        "bSortable": false
      }
    ]
  });
  debounceSearch('#employee-table')
}

const render_employee_pf_history_table = (employee_id) => {
  let scrollPosition = $(window).scrollTop();
  let table_id = '#employee-provident-fund-table';
  $(table_id).DataTable().destroy();
  $(table_id).DataTable({
    fixedHeader: true,
    pageLength: 10,
    processing: true,
    serverSide: true,
    searching: false,
    ajax: {
      'type': 'get',
      'url': `/employees/${employee_id}/show_pf_history`,
      'dataType': 'json',
      'data': (data) => {
        data.page = parseInt($(table_id).DataTable().page.info().page) + 1
        data.per_page = $(table_id).DataTable().page.info().length
        data.order = $(table_id).DataTable().order()[0][0]
        data.direction = $(table_id).DataTable().order()[0][1]
        data.from = $("#pf_history_from").val();
        data.to = $("#pf_history_till").val();
      }
    },
    "drawCallback": () => {
      if ($(table_id).DataTable().rows().count()) {
        $('#employee-provident-fund-table tr:last').attr('id', 'pf-history-net-total-row');
      }
    },
    deferRender: true,
    columnDefs: [
      {
        targets: '_all',
        'createdCell': (td, cellData, rowData, row, col) => {
          $(td).addClass('text-center')
        }
      },
      {
        targets: 3,
        bSortable: false
      }
    ]
  });
  $(window).scrollTop(scrollPosition);
  debounceSearch(table_id);
}

document.addEventListener("DOMContentLoaded", () => {
  $('.salary-edit-modal').on('hidden.bs.modal', () => {
    document.getElementById('salary-edit-form').reset();
  });
});

$(document).on('keyup', (e) => {
  if(e.key == 'Escape') {
    $('#employee_designations').modal('hide')
  }
});

$(document).on('click', '#clear-pkr-limit-btn', (e) => {
  $(e.target).closest('form').find("input[type='text'").val('')
})

$(document).on('change', '#select-employees-status, #select-user-type-filter, #select-business-unit-filter', (e) => {
  selectedSalarySlipEmployeeExternalIds.clear();
  $('#employee-table').DataTable().destroy();
  render_employees_table();
});

$(document).on("change", ".salary-slip-employee-checkbox", (e) => {
  if (e.target.checked) {
    selectedSalarySlipEmployeeExternalIds.add(e.target.value);
  } else {
    selectedSalarySlipEmployeeExternalIds.delete(e.target.value);
  }
  updateSelectedSalarySlipEmployeeCheckboxes();
});

$(document).on("change", "#select-all-salary-slips", (e) => {
  $(".salary-slip-employee-checkbox").each((_index, checkbox) => {
    checkbox.checked = e.target.checked;
    if (e.target.checked) {
      selectedSalarySlipEmployeeExternalIds.add(checkbox.value);
    } else {
      selectedSalarySlipEmployeeExternalIds.delete(checkbox.value);
    }
  });
  updateSelectedSalarySlipEmployeeCheckboxes();
});

$(document).on("click", "#download-selected-employee-salary-slips-btn", (e) => {
  e.preventDefault();
  if (selectedSalarySlipEmployeeExternalIds.size === 0) {
    alert("Please select at least one employee to download salary slips.");
    return;
  }

  $("#download-employee-salary-slips").modal("show");
});

$(document).on("submit", "#download-employee-salary-slips-form", () => {
  const selectedEmployeesContainer = $("#selected-salary-slip-employees");
  selectedEmployeesContainer.empty();
  selectedSalarySlipEmployeeExternalIds.forEach((employeeExternalId) => {
    selectedEmployeesContainer.append(
      $("<input>", {
        type: "hidden",
        name: "employee_external_ids[]",
        value: employeeExternalId,
      })
    );
  });
});

$(document).on('ajax:error ajax:success', '#salary-edit-form', (e) => {
  const { errors, success, url, warning_message } = e.detail[0];
  if (errors) {
    append_errors(errors, 'Cannot Add due to following issues:', $('.salary_history_ajax_errors'))
    removeErrorAndWarningMessage('.salary_modal', $('.salary_history_ajax_errors'))
  }
  if(warning_message) {
    displayWarningMessage(warning_message, $('.salary_history_warning_message'))
    removeErrorAndWarningMessage('.salary_modal', $('.salary_history_warning_message'))
  }
  if (success) {
    displaySuccessMessage(success, $('.salary_modal'))
    if ($('.merge_request').val() == 'true') {
      $('.merge_request').val(false)
    }
    refresh_salaries_table(url);
  }
});

$(document).on('ajax:error ajax:success', '#pkr-limit-form', (e) => {
  const { errors, success, html, warning_message } = e.detail[0];
  if (errors) {
    append_errors(errors, 'Cannot Add due to following issues:', $('.ajax_errors'))
    removeErrorAndWarningMessage('#pkr-limit-form', $('.ajax_errors'))
  }
  if(warning_message) {
    displayWarningMessage(warning_message, $('.warning_message'));
    removeErrorAndWarningMessage('#pkr-limit-form', $('.warning_message'))
  }
  if (success) {
    displaySuccessMessage(success, $('#add_pkr_limit'))
    $('#add_pkr_limit').html(html)
  }
});

$(document).on('click', '#provident-fund-tab', (e) => {
  let employee_id = e.target.closest('a').getAttribute('employee_id');
  render_employee_pf_history_table(employee_id);
})

const refresh_salaries_table = (url) =>{
  const employee_id = url.split('/')[2]
  $.ajax({
    type: 'GET',
    url: url,
    data: { employee_id: employee_id},
    dataType: 'JSON',
    success(response) {
      if (response.html !== ' ') {
        const salaryHistoryTable = $('#salary-history-table').DataTable()
        const salaryHistoryRows = $(response.html).filter('tr')
        salaryHistoryTable.clear().rows.add(salaryHistoryRows).draw()
      }
      $(`#employee-pkr-limit-${response.employee_id}`).val(response.pkr_limit)
    }
  });
}

const append_errors = (errors, message, error_message_div) => {
  const header_message = `<p class='text-danger px-4 pt-4'> <span class='fas fa-times-circle fa-lg mx-2'>\
                            </span> <strong>${message}</strong>\
                            <button class='close' type='button' id='close-errors-alert'> \
                              <span aria-hidden='true'>×</span> \
                              <span class='sr-only'>Close</span> \
                            </button> \
                          </p>`;
  error_message_div.removeClass('d-none')
  error_message_div.html(header_message);
  for (let error of Array.from(errors)) {
    const error_message = `<div class='text-danger px-5'> \
                              <ul> <li> ${error} </li></ul>\
                          </div>`;
    error_message_div.append(error_message);
  }
}

const displayWarningMessage = (warning_message, warning_message_div) => {
  const show_warning_message = `<div class='alert alert-warning w-100'><h6 class='pt-2'> ${warning_message}</h6>`
                                  "</div>";
    warning_message_div.removeClass('d-none')
    warning_message_div.html(show_warning_message);
    $('.merge_request').val(true)
}

const displaySuccessMessage = (message, modal) => {
  $('.alert-container').removeClass('d-none');
    const header_success_message = `<p class='text-success  px-4 pt-4'> <span class='fas fa-check-circle fa-lg mx-2'>\
                                </span><strong> ${message} </strong>\
                                <button class='close' data-dismiss='alert' type='button' id='close-success-alert'> \
                                <span aria-hidden='true'>×</span> \
                                <span class='sr-only'>Close</span> \
                                </button> \
                                </p>`;
    const success_message = `<div class='alert alert-success w-100'>\
                            <h6> ${header_success_message} </h6>`
    "</div>";
    $('.alert-container').html(success_message);
    modal.find('form').trigger('reset');
    modal.modal('hide');
    $('body').removeClass('modal-open');
    $('.modal-backdrop').remove();
    $('.alert-container').fadeTo(5000, 1000).slideUp(1000, function () {
      $('.alert-container').slideUp(1000);
    });
}

const removeErrorAndWarningMessage = (modal, message_div) => {
  $(document).on('hidden.bs.modal', `${modal}`, () => {
    if(!message_div.hasClass('d-none')) {
      message_div.addClass('d-none')
    }
    $('.merge_request').val(false)
  })
}

$(document).on('change', '.employee-activity-related-to, #activity_related_to', (e) =>{
  let form = $(e.target).closest('.employee-analytics-form');
  let selected_value = $(e.target).val();
  let allowances_dropdown = form.length ? form.find('.employee-allowances-dropdown') : $('#allowances_dropdown');
  let claims_dropdown = form.length ? form.find('.employee-claim-types-dropdown') : $('#claim_types_dropdown');
  let apply_filters_button = form.length ? form.find('.apply-analytics-filter') : $('#apply-data_insight_filters');

  if (selected_value == 'Allowances'){
    hide_and_clear_dropdown(claims_dropdown);
    show_dropdown(allowances_dropdown);
    apply_filters_button.prop('disabled', true);
  }
  else if(selected_value == 'Claims'){
    hide_and_clear_dropdown(allowances_dropdown);
    show_dropdown(claims_dropdown);
    apply_filters_button.prop('disabled', true);
  }
  else {
    hide_and_clear_dropdown(allowances_dropdown);
    hide_and_clear_dropdown(claims_dropdown);
    apply_filters_button.prop('disabled', false);
  }
});

$(document).on('change', '.employee-analytics-source', (e) => {
  let form = $(e.target).closest('.employee-analytics-form');
  let source_tabs = form.find('.employee-analytics-source-tabs label');

  source_tabs.removeClass('btn-dark active').addClass('btn-outline-secondary');
  $(e.target).closest('label').removeClass('btn-outline-secondary').addClass('btn-dark active');

  form[0].dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
});

$(document).on('change', '.employee-allowances-dropdown, .employee-claim-types-dropdown, #allowances_dropdown, #claim_types_dropdown', (e) => {
  let form = $(e.target).closest('.employee-analytics-form');
  let dropdown = $(e.target)
  let apply_filters_button = form.length ? form.find('.apply-analytics-filter') : $('#apply-data_insight_filters');
  let dropdown_visible = dropdown.data('multiselect') ? dropdown.parent().is(':visible') : dropdown.is(':visible');
  if (dropdown_visible && dropdown.val() == ''){
    apply_filters_button.prop('disabled', true);
  }
  else {
    apply_filters_button.prop('disabled', false);
  }
});

$(document).on('reset', '.employee-analytics-form', (e) =>{
  let form = $(e.target);
  hide_and_clear_dropdown(form.find('.employee-allowances-dropdown'));
  hide_and_clear_dropdown(form.find('.employee-claim-types-dropdown'));
  form.find('.custom-month-range-input').attr("readonly", true);
  form.find('.employee-activity-related-to').val(form.data('default-activity-related-to')).trigger('change');
  form.find('.salary-chart-tooltip-mode').prop('checked', false).trigger('change');
  disable_employee_analytics_salary_slip_download();
  display_employee_analytics(form);
})

$(document).on('click', '#employee_analytics_apply_analytics_filter', (e) => {
  if (!e.originalEvent) return;

  let form = $(e.target).closest('.employee-analytics-form');
  sync_employee_analytics_salary_slip_download(form.find('.custom-month-range-picker-container')[0]);
  form.data('enable-salary-slip-download-after-apply', true);
});

$(document).on('ajax:success', '.employee-analytics-form', (e) => {
  let form = $(e.target);
  if (!form.data('enable-salary-slip-download-after-apply')) return;

  enable_employee_analytics_salary_slip_download();
  form.removeData('enable-salary-slip-download-after-apply');
});

$(document).on('ajax:beforeSend', '.employee-analytics-form', () => {
  $('#employee_analytics_chart').html(employeeAnalyticsLoadingIndicator);
});

$(document).on('ajax:error', '.employee-analytics-form', (e) => {
  $('#employee_analytics_chart').html("<p class='text-center text-danger py-5'>Unable to load chart.</p>");
  $('#employee_analytics_summary').empty();
  $(e.target).removeData('enable-salary-slip-download-after-apply');
});

$(document).on('ajax:stopped', '.employee-analytics-form', (e) => {
  $(e.target).removeData('enable-salary-slip-download-after-apply');
});

$(document).on('ajax:beforeSend', '#employee_analytics_salary_slips_download_form', () => {
  $('#employee_analytics_download_salary_slips')
    .prop('disabled', true)
    .text('Generating...');
});

$(document).on('ajax:success', '#employee_analytics_salary_slips_download_form', (e) => {
  const response = (e.detail && e.detail[0]) || {};
  const errors = Array.isArray(response.errors) ? response.errors.join(', ') : response.errors;

  display_employee_analytics_salary_slip_message(
    response.message || errors || 'Salary slip generation request completed.',
    errors ? 'danger' : 'success'
  );
});

$(document).on('ajax:error', '#employee_analytics_salary_slips_download_form', (e) => {
  const response = (e.detail && e.detail[0]) || {};
  const xhr = e.detail && e.detail[2];
  const response_json = (xhr && xhr.responseJSON) || {};
  const errors = response.errors || response_json.errors;
  const message = response.message || response_json.message ||
    (Array.isArray(errors) ? errors.join(', ') : errors) ||
    'Unable to generate salary slips. Please try again.';

  display_employee_analytics_salary_slip_message(message, 'danger');
});

$(document).on('ajax:complete ajax:stopped', '#employee_analytics_salary_slips_download_form', () => {
  $('#employee_analytics_download_salary_slips').text('Download Salary Slips');
  enable_employee_analytics_salary_slip_download();
});

$(document).on('change', '.custom_month_range_picker_template', (e) => {
  initialize_custom_month_range($(e.target));
  let datepicker_container = e.target.closest('.custom-month-range-picker-container');
  if (datepicker_container && datepicker_container.id === 'employee_analytics_custom_month_range_picker_container') {
    disable_employee_analytics_salary_slip_download();
  }
  if(datepicker_container && datepicker_container.getAttribute('show-pf-history') === 'true') {
    render_employee_pf_history_table(datepicker_container.getAttribute('employee_id'));
  }
});

$(document).on('dp.update dp.change', '.custom-month-range-input', (e) => {
  let datepicker_container = e.target.closest('.custom-month-range-picker-container');
  if (!datepicker_container) return;
  const isPfHistory = datepicker_container.getAttribute('show-pf-history') === 'true';
  if (e.namespace !== (isPfHistory ? 'change' : 'update')) return;
  const container = $(datepicker_container);
  if (container.data('updating-range')) return;

  let date_inputs = container.find('.custom-month-range-input');
  let from_field = $(date_inputs[0]);
  let till_field = $(date_inputs[1]);

  if (!from_field.val() || !till_field.val()) return;
  container.data('updating-range', true);
  from_field.data("DateTimePicker").maxDate(isPfHistory ? moment(till_field.val(), 'MMM, YYYY').endOf('month') : till_field.val());
  till_field.data("DateTimePicker").minDate(isPfHistory ? moment(from_field.val(), 'MMM, YYYY').startOf('month') : from_field.val());
  container.data('updating-range', false);

  if (datepicker_container.id === 'employee_analytics_custom_month_range_picker_container') {
    disable_employee_analytics_salary_slip_download();
  }

  if (isPfHistory) {
    container.find('.custom_month_range_picker_template').val('Custom Select');
    render_employee_pf_history_table(datepicker_container.getAttribute('employee_id'));
  }
});

$(document).on('draw.dt', '#profile-claim-table', () => {
  let wrapper_width = $('#profile-claim-table_wrapper').find('.dt-scroll-body').width()
  $('#profile-claim-table').width(wrapper_width)
});

$(document).on('draw.dt', '.remarks-datatable', function () {
  let wrapper_width = $(this).closest('.dt-container').find('.dt-scroll-body').width()
  $(this).width(wrapper_width)
});

$(document).on('click', '#fetch-employee-data-btn', function (e) {
  e.stopPropagation();

  const $btn = $(this);
  const originalHtml = $btn.html();

  $btn.html('<i class="fa fa-spinner fa-spin"></i> Loading...');

  $.ajax({
    type: 'GET',
    url: `/employees/${$btn.data('id')}/fetch_data`,
    complete: () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      $btn.html(originalHtml);
    }
  });
});

$(document).on('show.bs.modal', '#download-salaries-history-csv', (e) => {
	$('#employees-status').val($('#select-employees-status').val());
})

const show_dropdown = (dropdown) => {
  container = dropdown.parent().closest('div')
  container.removeClass('d-none')
}

const display_employee_analytics = (form) => {
  if (form && form.length) {
    form.find('.apply-analytics-filter').trigger("click");
  }
}

const sync_employee_analytics_salary_slip_download = (datepicker_container) => {
  const date_inputs = $(datepicker_container).find('.custom-month-range-input');
  const from_month = $(date_inputs[0]).val();
  const till_month = $(date_inputs[1]).val();
  const download_form = $('#employee_analytics_salary_slips_download_form');

  download_form.find('[name="analytics_from"]').val(from_month);
  download_form.find('[name="analytics_till"]').val(till_month);
}

const enable_employee_analytics_salary_slip_download = () => {
  const download_form = $('#employee_analytics_salary_slips_download_form');
  const from_month = download_form.find('[name="analytics_from"]').val();
  const till_month = download_form.find('[name="analytics_till"]').val();
  const range_selected = Boolean(from_month && till_month);

  $('#employee_analytics_download_salary_slips').prop('disabled', !range_selected);
  $('#employee_analytics_salary_slips_filter_hint').toggleClass('d-none', range_selected);
}

const display_employee_analytics_salary_slip_message = (message, type) => {
  const alert = $('<div>', {
    class: `alert alert-dismissible alert-${type} text-center`,
    role: 'alert'
  });
  const close_button = $('<button>', {
    class: 'close',
    'data-dismiss': 'alert',
    type: 'button'
  }).append($('<span>', { 'aria-hidden': 'true' }).text('×'));

  $('.alert-container').empty().append(alert.append(close_button, document.createTextNode(message)));
  show_alert_container();
  window.scrollTo({ top: 0, behavior: 'smooth' });
}

const disable_employee_analytics_salary_slip_download = () => {
  const download_form = $('#employee_analytics_salary_slips_download_form');

  download_form.find('[name="analytics_from"], [name="analytics_till"]').val('');
  $('#employee_analytics_download_salary_slips').prop('disabled', true);
  $('#employee_analytics_salary_slips_filter_hint').removeClass('d-none');
}

const initialize_remarks_datatable = () => {
  const initialize_visible_tables = (container) => {
    $(container).find('.remarks-custom-datatable:visible').each(function () {
      if ($.fn.DataTable.isDataTable(this)) return;

      $(this).DataTable({ scrollY: '350px', scrollCollapse: true, pageLength: 10 });
    });
  }

  initialize_visible_tables(document);

  $(document).on('shown.bs.tab', '#remarks-tab, #pills-tab a[data-toggle="pill"]', () => {
    initialize_visible_tables('#remarks');
  });

  $(document).on('shown.bs.modal', '#view-remarks-modal', () => {
    initialize_visible_tables('#view-remarks-modal');
  });
}

const set_month_picker_max = (field, maxMonth) => {
  if (!maxMonth || !field.data("DateTimePicker")) return;

  field.data("DateTimePicker").maxDate(moment(maxMonth).endOf('month'));
}

const cap_month_field = (field, maxMonth) => {
  if (!maxMonth || !field.val()) return;

  const maxDate = moment(maxMonth).endOf('month');
  const selectedDate = moment(field.val(), 'MMM, YYYY').endOf('month');
  if (selectedDate.isAfter(maxDate)) {
    field.val(maxDate.format('MMM, YYYY'));
  }
}

const set_custom_month_range = (currentSalaryMonth, maxMonth, range, from_field, till_field) => {
  const effectiveEndMonth = maxMonth || currentSalaryMonth;
  var rangeStart, rangeEnd
  switch(range){
    case "Current Month":
      rangeStart = moment(effectiveEndMonth).startOf('month')
      rangeEnd = moment(effectiveEndMonth).endOf('month')
      break
    case "Previous Month":
      rangeStart = moment(currentSalaryMonth).subtract(1, 'month').startOf('month')
      rangeEnd = moment(currentSalaryMonth).subtract(1, 'month').endOf('month')
      break
    case "Last 3 Months":
      rangeStart = moment(currentSalaryMonth).subtract(3, 'month').startOf('month')
      rangeEnd = moment(currentSalaryMonth).subtract(1, 'month').endOf('month')
      break
    case "Last 6 Months":
      rangeStart = moment(currentSalaryMonth).subtract(6, 'month').startOf('month')
      rangeEnd = moment(currentSalaryMonth).subtract(1, 'month').endOf('month')
      break
    case "Last 12 Months":
      rangeStart = moment(currentSalaryMonth).subtract(1, 'year').startOf('month')
      rangeEnd = moment(currentSalaryMonth).subtract(1, 'month').endOf('month')
      break
    case "Current Fiscal Year to Date":
      if( moment(effectiveEndMonth).quarter() < 3 ){
        rangeStart = moment(effectiveEndMonth).subtract(1, 'year').month('July').startOf('month')
      }
      else {
        rangeStart = moment(effectiveEndMonth).month('July').startOf('month')
      }
      rangeEnd = moment(effectiveEndMonth).endOf('month')
      break
    case "Previous Fiscal Year":
      if( moment(currentSalaryMonth).quarter() < 3 ){
        rangeStart = moment(currentSalaryMonth).subtract(2, 'year').month('July').startOf('month')
        rangeEnd = moment(currentSalaryMonth).subtract(1, 'year').month('June').endOf('month')
      }
      else {
        rangeStart = moment(currentSalaryMonth).subtract(1, 'year').month('July').startOf('month')
        rangeEnd = moment(currentSalaryMonth).month('June').endOf('month')
      }
      break
    default:
      rangeStart = moment(currentSalaryMonth).startOf('month')
      rangeEnd = moment(currentSalaryMonth).endOf('month')
  }

  from_field.val(rangeStart.format('MMM, YYYY'))
  till_field.val(rangeEnd.format('MMM, YYYY'))
  cap_month_field(till_field, maxMonth)
}

const initialize_custom_month_range = (dropdown) => {
  let selected_value = dropdown.val();
  let datepicker_container = dropdown.closest('.custom-month-range-picker-container');
  if (!datepicker_container.length) return;

  let currentSalaryMonth = datepicker_container.attr('data-current-salary-month');
  let maxMonth = datepicker_container.attr('data-max-month');
  let date_inputs = datepicker_container.find('.custom-month-range-input');
  let from_field = $(date_inputs[0]);
  let till_field = $(date_inputs[1]);

  const isPfHistory = datepicker_container.attr('show-pf-history') === 'true';
  if (isPfHistory) {
    datepicker_container.data('updating-range', true);
    from_field.data('DateTimePicker').maxDate(moment(maxMonth).endOf('month'));
    till_field.data('DateTimePicker').minDate(moment(from_field.data('min-date')).startOf('month'));
  }
  set_month_picker_max(till_field, maxMonth);

  if (selected_value == 'Custom Select'){
    datepicker_container.find(".custom-month-range-input").attr("readonly", false);
    cap_month_field(till_field, maxMonth);
    from_field.datetimepicker("show");
  }
  else{
    datepicker_container.find(".custom-month-range-input").attr("readonly", true);
    set_custom_month_range(currentSalaryMonth, maxMonth, selected_value, from_field, till_field)
    if (isPfHistory) {
      from_field.data('DateTimePicker').date(moment(from_field.val(), 'MMM, YYYY'));
      till_field.data('DateTimePicker').date(moment(till_field.val(), 'MMM, YYYY'));
    }
  }
  if (isPfHistory) datepicker_container.data('updating-range', false);
}
